module.exports = __webpack_public_path__ + "img/pro_s3_img4.2dd19627.jpg";